<template>
  <svg class="animate-spin" width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 2C25.9556 2 29.8224 3.17298 33.1114 5.37061C36.4004 7.56824 38.9638 10.6918 40.4776 14.3463C41.9913 18.0009 42.3874 22.0222 41.6157 25.9018C40.844 29.7814 38.9392 33.3451 36.1421 36.1422C33.3451 38.9392 29.7814 40.844 25.9018 41.6157C22.0222 42.3874 18.0008 41.9913 14.3463 40.4776C10.6918 38.9638 7.56821 36.4004 5.37059 33.1114C3.17297 29.8224 1.99999 25.9556 2 22" stroke="#074EE8" stroke-width="4"/>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/runtime-core'

const LoadingIconLarge = defineComponent({})
export default LoadingIconLarge
</script>
